export default "__VITE_PUBLIC_ASSET__8bc00e55__"